import React from 'react';

// styles
import { Logo as LogoPage, StyleLogo } from '../Home/style';
import { Garanta, Info, Container } from './style';

// images
import ImageLogo from '../../../assets/images/logo.png';

const Header = () => {
  return (
    <>
      <Container>
        <LogoPage>
          <StyleLogo
            src={ImageLogo}
            alt={'Fábrica do Livro'}
            title={'Fábrica do Livro'}
          />
        </LogoPage>
        <Garanta>
          <h1>Garanta o Dobro de</h1>
          <h1>desconto</h1>
          <Info>Aqui as informações são mais detalhadas</Info>
          <p>mas é rapidinho de responder:</p>
        </Garanta>
      </Container>
    </>
  );
};

export default Header;
